import { Pipe, PipeTransform } from '@angular/core';
import en from '../../../assets/i18n/en.json';
import { TranslatePipe } from '@ngx-translate/core';

@Pipe({
    name: 'translateValue',
    standalone: true,
})
export class TranslateValuePipe extends TranslatePipe implements PipeTransform {
    transform(value: string | null | undefined, extraTranslationGroups?: string[]): string {
        if (!value) return '';

        let keyOfValue = value;

        const groups: Record<string, string[]> = {};

        const defaultTranslations = en as Record<string, Record<string, string>>;

        if (extraTranslationGroups && extraTranslationGroups.length > 0) {
            extraTranslationGroups.forEach(iGroupKey => {
                if (iGroupKey in en) {
                    groups[iGroupKey] = Object.keys(defaultTranslations[iGroupKey]);
                }
            });
        }

        Object.assign(groups, {
            general: Object.keys(en.general),
            messages: Object.keys(en.messages),
        });

        for (const iGroupKey in groups) {
            const keys = groups[iGroupKey];
            const iResult = keys.find(
                key => defaultTranslations[iGroupKey][key].toLowerCase() === (value ?? '').toString().toLowerCase()
            );

            if (iResult != undefined) {
                keyOfValue = `${iGroupKey}.${iResult}`;
                break;
            }
        }

        const translated = super.transform(keyOfValue);
        return translated && translated !== keyOfValue ? translated : value ?? '';
    }
}
